<div *ngIf="canShowData()">
  <div class="flex-row gap-16">
    <ng-container *ngIf="productionScheduleItem.finishing">
      <span vdw-ellipsis-label [text]="productionScheduleItem.finishing.nameWithVersion" matTooltipPosition="above"> </span>
      <div class="flex-1 flex-end-center" class="info-balloon-container">
        <mat-icon class="finishing-info" svgIcon="info" (click)="showFinishingDetails($event, productionScheduleItem)"></mat-icon>
      </div>
    </ng-container>
  </div>
</div>
